// GENERAL SCRIPTS
if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    'use strict';
    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var rpt = '';
    for (var i = 0; i < count; i++) {
      rpt += str;
    }
    return rpt;
  }
}

// FLASH MESSAGES
function flash(text, type) {
  text = typeof text !== 'undefined' ? text : 'Something went wrong';
  type = typeof type !== 'undefined' ? type : 'success';
  var flashClass = type === 'success' ? 'flashMsg__success' : 'flashMsg__error';
  var msg = '<p class="flashMsg text__snowy text__narrow ' + flashClass + '">' + text + '</p>';
  $('body').find(".flashMsg").remove();
  $('body').append(msg);
  $('.flashMsg').fadeIn();
  setTimeout(function(){
    $('.flashMsg').fadeOut(function() {
      $(this).remove();
    });
  }, 5000);
}
// CURRENT NAV ON MOBILE
function currentNavInfo() {
  var current = $('.nav-link.link__current')
  var text = current.find('.nav-link-text').text();
  var badge = parseInt(current.find('.badge').text());
  var navInfoText = $('.nav-info-text');
  var navInfoBadge = $('.nav-info-badge');
  navInfoText.text(text);
  if ( isNaN(badge) ) {
    navInfoBadge.addClass('hide');
  } else {
    navInfoBadge.text(badge).removeClass('hide');
  }
}
// UPDATE COUNTER
function counter(counts) {
  $('.assets').find('.badge').not('.badge__static').each(function(i, el){
    $(el).text(counts[i]);
  });
  currentNavInfo();
}

// UPDATE NOTES ICON(empty or not)
function notesUpdate(notes) {
  var noteToggle = $('#noteToggle');
  notes > 0 ? noteToggle.removeClass('empty') : noteToggle.addClass('empty');
}
function popupOpen(id) {
  $('#' + id).addClass('popup__open');
  $('html').addClass('noScroll');
  $('body').addClass('noScroll');
}
function popupClose(id) {
  $('#' + id).removeClass('popup__open');
  if(!$('.nav-wrapper').hasClass('nav__collapsed')) {
    $('html').removeClass('noScroll');
    $('body').removeClass('noScroll');
  }
}
// PAGER
function pager(btn, cb, wrapper, path) {
  wrapper = typeof wrapper !== 'undefined' ? wrapper : 'panels';
  path = typeof path !== 'undefined' ? path : btn.attr('href');
  $.get(path, function(data) {
    $('#' + wrapper).html(data.html);
    MJReinit(wrapper, function() {
      cb && cb();
    });
    $('#' + wrapper).find('.select-list').chosen({width: "100%", disable_search_threshold: 10});
    $('#' + wrapper).find('.select-list-optional').chosen({width: "100%", disable_search_threshold: 10, allow_single_deselect: true});
    notesUpdate(data.hasUnread);
    counter(data.counter);
  }).fail(function(data) {
    flash(data.msg, 'error');
  })
}

// OPEN REMOVE POPUP
function removePopup(btn, text) {
  var popup = $('#remove');
  popup.find('.confirm-remove').attr('data-removable', btn.data('id'));
  popup.find('.text__main').text(text);
}

// CONFIRM REMOVE
function confirmRemove(btn, path, wrapper, type, cb) {
  wrapper = typeof wrapper !== 'undefined' ? wrapper : 'panels';
  var obj = {id: btn.attr('data-removable')};
  type && (obj.type = type);
  btn.addClass('loading');
  $.post(path, obj, function(data) {
    pager($('.currentPager'), function() {
      btn.removeClass('loading');
      popupClose('remove');
      flash(data.msg);
      cb && cb();
    }, wrapper);

  }).fail(function(data) {
    flash(data.msg, 'error');
  })
}

function scrollToElement(el) {
  var scrollTo = el.offset().top - $('.header').innerHeight() - 30;
  $("html, body").animate({scrollTop: scrollTo}, "slow");
}

function openTab(href) {
  //var id = tab.attr('id');
  $('.tabs-link').removeClass('link__current');
  $('[href="' + href + '"]').addClass('link__current');
  $('.tab').removeClass('tab__current');
  $(href).addClass('tab__current');
}
function switchTooltip(select, info) {
  var tooltipWrapper = select.parent().next(),
     text = info[parseInt(select.val()) - 1];
  if (text) {
      tooltipWrapper.removeClass('hide');
      tooltipWrapper.find('.tooltip-text').text(text);
  }
}
function toggleText(btn, tt, ft, btnSibling) {
  btn.toggleClass("text__highlighted text__secondary");
  var t = btn.hasClass("text__highlighted") ? tt : ft;
  btn.text(t);
  btnSibling && btnSibling.toggleClass('hide');
}
$(document).ready(function(){

	// GENERAL VARIABLES
	var body = $('body');

	// for making pseudo-elements work on ios
	$('body *').on('touchstart', function (){});

	// detects if it's touch device or not and add class
	if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) ||
	(navigator.msMaxTouchPoints > 0)) {
    body.addClass("touch");
	} else{
    body.addClass("no-touch");
	}

  // DROPDOWN TOGGLE
  $('.dropdown-toggle').click(function() {
    var currentMenu = $(this).parent().find('.dropdown-menu');
    $('.dropdown-menu').not(currentMenu).removeClass('open');
    currentMenu.toggleClass('open');
  });
  $(document).click(function() {
    $('.dropdown-menu').removeClass('open');
  });
  $('.dropdown-menu, .dropdown-toggle').click(function(e) {
    e.stopPropagation();
  });

  //POPUPS
  $(document).on('click', '[data-popup]', function(e){
    e.preventDefault();
    var _ = $(this),
        id = _.data("popup"),
        popup = $('#' + id);
    popupOpen(id);
    if (id === 'treeSimple') {
      var mscId = _.attr('data-mscId'),
          content = popup.find('.popup-content');
      content.append('<div class="preloader"></div>');
      $.ajax({
        url: "/msc/search?query=" + mscId + "&d=true"
      }).done(function(data) {
        content.find('.preloader, .tree-root__parent').remove();
        content.append(data);
        MJReinit('treeSimple');
      });

    }
    if (id === 'follow') {
      $('#followHidden').val(_.data('id'));
    }
    if (id === 'followUser') {
      $('#followUserHidden').val(_.data('id'));
    }
    if (id === 'social') {
      var shareUrl = _.attr('data-url'),
          hashtags = _.attr('data-hashTags'),
          summary = _.attr('data-summary'),
          title = _.attr('data-title');
          const hrefs = [
            'https://www.facebook.com/sharer/sharer.php?u=URLPLACEHOLDER',
            'https://twitter.com/intent/tweet?url=URLPLACEHOLDER&hashtags=HASHTAGPLACEHOLDER&text=SUMMARYPLACEHOLDER',
            'https://www.linkedin.com/shareArticle?mini=true&url=URLPLACEHOLDER&title=TITLEPLACEHOLDER&summary=SUMMARYPLACEHOLDER&source=SciLag'
          ]
      $('#social .social-link').each(function(i) {
          var _ = $(this),
              href = hrefs[i];
          href = href.replace('URLPLACEHOLDER', shareUrl).replace('HASHTAGPLACEHOLDER', hashtags).replace('SUMMARYPLACEHOLDER', summary).replace('TITLEPLACEHOLDER', title);
          _.attr('href', href);
      });
    }
    if (id === 'addLabel') {
      var input = $('#ref-label');
      if (input.hasClass('error')) {
        input.removeClass('error').val('');
        input.next('.msg').remove();
      }
    }
  });

  $('.popup, .popup-close').click(function(e){
    var _ = $(this),
        id = _.hasClass('popup') ? _.attr('id') : _.parents('.popup').attr('id');
    popupClose(id);

    // some specific conditions when closing popup
    //if(_.is('#subscribe')) {
      //$('#subscribe-email').val('');
      //$('#popup-subEmail').val('');
    //}
    if(_.is('#treeSimple')) {
     _.find('.tree-root__parent').remove();
    }
    if(_.is('#login')) {
      $('#login-form').removeClass('hide');
      _.find('.popup-title').text('Log in');
      $('#passReset-form').addClass('hide');
    }

  });

  $('.popup-content').click(function(e){
    e.stopPropagation();
  });

  // TABS
  $('.tabs-link').click(function(e){
    e.preventDefault();
    openTab($(this).attr('href'));
  });

  // SLIDE TOGGLING
  $(document).on('click', '.slideToggle', function() {
    var _ = $(this);
    if (_.hasClass('panel-slideToggle')) {
      _.toggleClass('panel-slideToggle__collapsed');
    } else {
      _.toggleClass('icon-plus-square icon-minus-square');
    }
    _.next().slideToggle();
  });

  // SLIDE TOGGLING
  $(document).on('click', '.slideAsync', function () {
    var _ = $(this),
        type = _.data('for');

    if (!_.hasClass('hasData')) {
      _.addClass('loading__action');
      $.get('/publicationExtraData', {type: type, id: _.data('id')}, function (data) {
        console.log(data);
        
        $.each(data, function (key, value) {
          console.log(key);
          
          _.siblings('.' + key).addClass('hasData');
          _.siblings('.' + key + 'Area').html(value);
        });
        _.addClass('hasData');
        _.removeClass('loading__action');
        if (_.hasClass('icon-plus-square')) { //It's closed and we want to open
          _.siblings('.togglingBlock').slideUp();
          _.siblings('.slideAsync').removeClass('icon-minus-square').addClass('icon-plus-square ');
        }
        _.toggleClass('icon-plus-square icon-minus-square');
        _.siblings('.' + type + 'Area').slideToggle();
      }).fail(function () {
        _.removeClass('loading__action');
        flash('Something went wrong', 'error');
      })
    } else {
      if (_.hasClass('icon-plus-square')) { //It's closed and we want to open
        _.siblings('.togglingBlock').slideUp();
        _.siblings('.slideAsync').removeClass('icon-minus-square').addClass('icon-plus-square ');
      }
      _.toggleClass('icon-plus-square icon-minus-square');
      _.siblings('.' + type + 'Area').slideToggle();
    }
  });

  // main search toggle
  $('#search-toggle').click(function() {
    $('.header-search').addClass('header-search__show');
  });
  $('.search-close').click(function() {
    $('.header-search').removeClass('header-search__show');
  });

  // PASS RESET
  $('#passReset').click(function(e) {
    e.preventDefault();
    $('#login-form').addClass('hide');
    $('#login').find('.popup-title').text('Password reset');
    $('#passReset-form').removeClass('hide');
  });

  // FOOTER SUBSCRIBE
  $('#subscribe-email').on('change', function() {
    var popupEmail = $('#subscribe_email');
    popupEmail.removeClass('error').val($(this).val());
    popupEmail.parent().find('.msg').remove();
  });

  // OVERVIEW TOGGLE
  // $(document).on('click', '.overview-toggle', function() {
  //   var _ = $(this),
  //       scrollTo = _.parents('.panel').offset().top - $('.header').innerHeight() - 10;
  //   _.find('.action-icon').toggleClass('icon-plus-square icon-minus-square');
  //   _.parent().next().slideToggle('slow');
  //   $("html, body").animate({ scrollTop: scrollTo }, "slow");
  // });
  $(document).on("click", ".btn__close", function () {
    $(this).parent().addClass('hide');
  })
});

